import axios from 'axios';

import { getMicroservicesDomain, handleNotFoundError, handleUnauthorizedError } from '../utils';
import { getDefaultHeaders } from '../utils/http';

const baseURL = `${getMicroservicesDomain()}/stores`;

export async function getDevices() {
    const headers = await getDefaultHeaders();
    try {
        const { data } = await axios({
            method: 'get',
            baseURL,
            url: '/locations/devices',
            headers,
        });
        return data.data;
    } catch (e) {
        handleUnauthorizedError(e);
        return [];
    }
}

export async function getDevice({ locationID, deviceID }) {
    const headers = await getDefaultHeaders();
    try {
        const { data } = await axios({
            method: 'get',
            baseURL,
            url: `/locations/${locationID}/devices/${deviceID}`,
            headers,
        });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        return null;
    }
}

export async function addDevice(device) {
    const headers = await getDefaultHeaders();
    try {
        const { data } = await axios({
            method: 'post',
            baseURL,
            url: `/locations/${device.locationID}/devices`,
            data: device,
            headers,
        });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        return null;
    }
}

export async function updateDevice(device, params) {
    const headers = await getDefaultHeaders();
    try {
        const { data } = await axios({
            method: 'put',
            baseURL,
            url: `/locations/${device.locationID}/devices/${params.id}`,
            data: device,
            headers,
        });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        return null;
    }
}

export async function deleteDevice(deviceID) {
    const headers = await getDefaultHeaders();
    try {
        const { data } = await axios({
            method: 'delete',
            baseURL,
            url: `/devices/${deviceID}`,
            headers,
        });
        return data;
    } catch (e) {
        handleNotFoundError(e);
    }
}
